// R13 Workstream 5 - the wizard may place an opportunity on a different stage, but a PROCESS-category
// stage is a historical migration (evidence, attestation, owners), never an "advanced stage" choice.
export const requiresHistoricalMigration = ({ advancedStage, stages, stageId }) => {
  const defaultStage = (stages || [])[0];
  const isDefault = !stageId || !defaultStage || stageId === defaultStage.stage_id;
  if (!advancedStage || isDefault) return false;
  return (stages || []).find((s) => s.stage_id === stageId)?.category === "process";
};

// The migration form's draft status line, from the backend's own list of missing prerequisites.
export const migrationStatusText = (rec) => {
  if (!rec) return "";
  const n = (rec.missing_prerequisites || []).length;
  return n ? `Draft - no Case exists yet. ${n} prerequisite${n === 1 ? "" : "s"} missing:` : "Every prerequisite is present.";
};

// What a Process-stage placement needs. The wizard shows this list when someone picks a Process stage with only a
// free-text reason, so the person sees exactly what is missing; the backend (historical_case_migration.py) is the
// authority and re-checks every one of them.
export const MIGRATION_PREREQUISITES = [
  { code: "consultation", label: "Consultation outcome (signup) or a truthful legacy equivalent, with evidence" },
  { code: "signup_date", label: "Signup date" },
  { code: "signup_evidence", label: "Signup evidence (document or record reference)" },
  { code: "payment", label: "Payment evidence, or a documented payment exception" },
  { code: "leadership_attestation", label: "Leadership attestation that the evidence was checked" },
  { code: "owners", label: "Sales owner and process owner (or process team)" },
  { code: "legacy_case_ref", label: "Legacy Case / file reference and historical opportunity reference" },
  { code: "migration_source", label: "Migration source" },
  { code: "test_classification", label: "Explicit TEST / real classification" },
];
